import {CtModelRouteData} from "@ctsolution/ct-framework";

export const OfferFeeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("offerfee");
